import actions from './wishlist.actions.js';
import mutations from './wishlist.mutations.js';
import state from './wishlist.state.js';

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
